<template>
    <div class="pb-5">
        <data-table ref="animals"
                    :api-route="backendApiRoute"
                    :api-view-set="animalsDataTable.apiViewSet"
                    :name="animalsDataTable.name"
                    :columns="animalsDataTable.columns"
                    :search="animalsDataTable.search"
                    :search-placeholder="animalsDataTable.searchPlaceholder"
                    :filters="animalsDataTable.filters ? animalsDataTable.filters : []"
                    :actions="animalsDataTable.actions"
                    :orderings="animalsDataTable.orderings"
                    :initial-orderings="animalsDataTable.initialOrderings"
                    :row-actions="animalsDataTable.rowActions"
                    :toggle-row-component="animalsDataTable.toggleRowComponent"
                    :key="animalsDataTable.key"
                    :show-select-row-column="canWorkWithArchive()"
                    @filter-reset="onFilterReset">
            <template #extraActionControl>
                <b-collapse id="archive-control" v-model="archiveControlsVisible" v-if="canWorkWithArchive()">
                    <div class="d-flex flex-wrap mb-3 bg-light rounded p-2 p-md-3 pb-3 pb-md-4">
                        <div class="d-flex flex-column flex-grow-1">
                            <div class="d-flex flex-column">
                                <div class="d-flex flex-column">
                                    <small class="flex-grow-0 mr-2 text-secondary">Отображение архивированных записей</small>
                                    <div class="d-flex align-items-center flex-wrap flex-grow-0 p-2">
                                        <b-form-radio @change="onArchiveControlTypeChanged" v-model="archiveControlType" name="archive-control-types" value="0" class="mr-4 mb-2">Все</b-form-radio>
                                        <b-form-radio @change="onArchiveControlTypeChanged" v-model="archiveControlType" name="archive-control-types" value="3" class="mr-4 mb-2">Актуальные</b-form-radio>
                                        <b-form-radio @change="onArchiveControlTypeChanged" v-model="archiveControlType" name="archive-control-types" value="1" class="mr-4 mb-2">К архивированию (созданы более 3 лет назад) </b-form-radio>
                                        <b-form-radio @change="onArchiveControlTypeChanged" v-model="archiveControlType" name="archive-control-types" value="2" class="mr-4 mb-2">К удалению (перемещены в архив)</b-form-radio>
                                    </div>
                                </div>
                                <div class="col-xs-12 col-lg-10 col-xl-6 col-xxl-4 p-0 m-0" v-if="parseInt(archiveControlType) === 2">
                                    <data-table-date-from-to-filter ref="archiveDate"
                                                                    :filter="getArchiveDateFilter()"
                                                                    :initial-value-from="getInitialArchiveDateFromFilter()"
                                                                    :initial-value-to="getInitialArchiveDateToFilter()"
                                                                    v-on:filter-added="onArchiveDateFilterAdded"
                                                                    v-on:filter-removed="onArchiveDateFilterRemoved" />
                                </div>
                            </div>
                            <div class="d-flex flex-column flex-sm-row align-items-start align-items-sm-center mt-3" v-if="getSelectedRowIds().length">
                                <span class="mr-2 mb-2">{{ getSelectedLabel() }}</span>
                                <b-button v-if="parseInt(archiveControlType) === 1" variant="info" class="mr-2 mb-2" @click="onMoveToArchiveClick">Переместить в архив</b-button>
                                <b-button v-if="parseInt(archiveControlType) === 2" variant="primary" class="mr-2 mb-2" @click="onReturnFromArchiveClick">Вернуть из архива</b-button>
                                <b-button v-if="parseInt(archiveControlType) === 2" variant="danger" class="mr-2 mb-2" v-b-modal="'delete-irreversibly'" @click="showIrreversibleDeleteModal">Удалить безвозвратно</b-button>
                            </div>
                        </div>
                    </div>

                </b-collapse>
            </template>
        </data-table>

        <data-table-irreversible-delete-modal ref="deleteIrreversibly" :url="getIrreversibleDeleteUrl()" @irreversible-delete-success="onIrreversibleDeleteSuccess">
            <template #genitiveObjectName>{{ getAnimalGenitive() }}</template>
            <template #linkedObjectsText><span>Также будут удалены связанные <strong>мероприятия</strong> и прикрепленные к ним медиафайлы.</span></template>
        </data-table-irreversible-delete-modal>

    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import api from "../../../api";
    import DataTable from "../../../components/Table/DataTable";
    import DataTableDateFromToFilter from "@/components/Table/DataTableDateFromToFilter.vue";
    import actions, {Action} from "../../../components/Table/actions";
    import {Animal} from "./animal";
    import {download} from "@/components/Files/download";
    import EventBus from "@/bus";
    import {ACTIVITIES} from "@/store/auth/auth";
    import httpClient from "@/http";
    import {ArchiveMixin} from "@/pages/Common/archiveMixin";
    import DataTableIrreversibleDeleteModal from "@/components/Table/DataTableIrreversibleDeleteModal.vue";

    export default {
        name: "AnimalsList",
        components: {
            DataTableIrreversibleDeleteModal,
            DataTable,
            DataTableDateFromToFilter
        },
        mixins: [ArchiveMixin],
        computed: {
            ...mapGetters(['ability', 'isSuperuser', 'isInController', 'hasMunicipalityRestrictions', 'userOrganizationActivities', 'getFilters']),
            backendApiRoute() { return api.animals.default.list() }
        },
        data() {
            let table = {
                name: 'animals-table',
                key: 'animals-table',
                apiViewSet: api.animals.default,
                search: true,
                searchPlaceholder: 'Поиск по номеру животного, чипа, бирки',
                columns: [
                    { name: 'id', 'title': '',
                        cellComponentName: 'AnimalToggleRowCell',
                        cellComponentPath: 'src/pages/DataTableCells/'},
                    { name: 'description_object', 'title': 'Животное',
                        extraDataFrom: ['species_name', 'breed_name'],
                        cellComponentName: 'AnimalAvatarCell',
                        cellComponentPath: 'src/pages/DataTableCells/'},
                    { name: 'shelter_object', 'title': 'В приюте',
                        cellComponentName: 'AnimalShelterCell',
                        cellComponentPath: 'src/pages/DataTableCells/'},
                    { name: 'shelter_object.alive', 'title': 'Жив',
                        cellComponentName: 'AnimalAliveCell',
                        cellComponentPath: 'src/pages/DataTableCells/'},
                    { name: 'last_catching_object.execution_date_short',
                        'title': 'Последний отлов', extraDataFrom: 'last_catching_object.request_object',
                        cellComponentName: 'AnimalLastCatchingCell',
                        cellComponentPath: 'src/pages/DataTableCells/'},
                    { name: 'last_catching_object.event_address_object.short_text', 'title': 'Адрес отлова'},
                    { name: 'label_id', 'title': 'Бирка'},
                    { name: 'chip_id', 'title': 'Чип'},
                    { name: 'last_survey_object.execution_date_short', 'title': 'Освидетельствование'},
                    { name: 'last_vaccination_object.execution_date_short', 'title': 'Вакцинация'},
                    { name: 'last_sterilization_object.execution_date_short', 'title': 'Стерилизация'},
                    { name: 'shelter_object.return_date', 'title': 'Возврат', extraDataFrom: ['shelter_object.return_target']},
                    { name: 'last_return_to_owner_object.attributes.ownerName', 'title': 'Владелец'},
                    { name: 'last_keeping_object.executor_contract_object.contractor_object.name',
                        'title': 'Место последнего нахождения животного',
                        extraDataFormat: 'Контракт №{{}}',
                        extraDataFrom: 'last_keeping_object.executor_contract_object.number'},
                    { name: 'last_keeping_object.event_address_object.short_text', 'title': 'Источник поступления'},

                ],
                orderings: [
                    {'description_object': 'reg_number'},
                    'label_id',
                    'chip_id',
                    'archive_date'
                    // {'species_name': 'breed__species'},  // TODO: сортировка с группированными полями
                    // {'breed_name': 'breed'},
                    // {'gender_name': 'gender'},
                ],
               initialOrderings: {
                    'description_object': 2
               },
                actions: [],
                rowActions: [],
                filters: [
                    { title: 'Вид', name: 'breed_species', label: 'species',
                        source: api.species.default.list() },
                    { title: 'Порода', name: 'breed', label: 'breed',
                        source: api.breeds.default.list(), labelKey: 'full_name'},
                    { title: 'Пол', name: 'gender', label: 'gender',
                        source: api.animals.genders.list() },
                    { title: 'Дата последнего отлова', name: 'catching_date', type: 'dateFromTo' },
                    { title: 'Населенный пункт отлова', name: 'catching_municipality',
                        source: api.municipalities.default.list(), labelKey: 'short_name' },
                    { title: 'Населенный пункт - источник поступления', name: 'keeping_source_municipality',
                        source: api.municipalities.default.list(), labelKey: 'short_name' },
                    { title: 'Содержится в', name: 'keeping_place', source: `${api.animals.shelters.list()}`},
                    { title: 'Выбыл из', name: 'left_place', source: `${api.animals.shelters.list()}`}
                ],
                toggleRowComponent: {
                    cellComponentName: 'AnimalToggleRow',
                    cellComponentPath: 'src/pages/DataTableToggleRows/'
                }
            }

            if (this.$store.getters.isInController) {
                table.columns.splice(4, 0,
                    { name: 'last_survey_object.attributes.conclusionChoice', 'title': 'Агрессивен',
                            cellComponentName: 'AnimalAggressiveCell',
                            cellComponentPath: 'src/pages/DataTableCells/'})
            }

            return {
                animalsDataTable: table,
            }
        },
        methods: {
            getTableRef() {
                return this.$refs.animals
            },
            getArchiveUrl() {
                return api.animals.archive.list()
            },
            getExtractUrl() {
                return api.animals.extract.list()
            },
            getDeleteUrl() {
                return api.animals.deleteIrreversibly.list()
            },
            getAnimalGenitive() {
                const len = this.getSelectedRowIds().length;
                const rem = len % 10;
                if (rem === 1 && (len < 10 || len > 20)) {
                    return 'животное'
                }
                else {
                    return 'животных'
                }
            },

            getInitialArchiveDateFromFilter() {
                const storedFilters = this.getFilters(this.animalsDataTable.name);
                for (const filter of storedFilters) {
                    if (filter['key'] === 'archive_date_from') {
                        return filter
                    }
                }
                return null;
            },

            getInitialArchiveDateToFilter() {
                const storedFilters = this.getFilters(this.animalsDataTable.name);
                for (const filter of storedFilters) {
                    if (filter['key'] === 'archive_date_to') {
                        return filter
                    }
                }
                return null;
            },
        },
        beforeMount() {
            if (this.canWorkWithArchive()) {
                const storedFilters = this.getFilters(this.animalsDataTable.name);
                let storedArchiveControlType = null;
                for (const storedFilter of storedFilters) {
                    if (storedFilter['key'] === 'needs_archive') {
                        storedArchiveControlType = '1'
                    }
                    if (storedFilter['key'] === 'is_archived') {
                        storedArchiveControlType = '2'
                    }
                    if (storedFilter['key'] === 'is_actual') {
                        storedArchiveControlType = '3'
                    }
                    if (storedArchiveControlType !== null) {
                        this.archiveControlType = storedArchiveControlType;
                        this.archiveControlsVisible = true
                        break
                    }
                }
            }
        },
        mounted() {
            const vm = this;
            if (vm.isSuperuser || vm.isInController) {
                vm.animalsDataTable.filters.push({
                    title: 'Агрессивность животного',
                    name: 'aggression_level',
                    source: `${api.animals.aggressionLevels.list()}`
                })
                if (vm.isSuperuser || !vm.hasMunicipalityRestrictions && vm.userOrganizationActivities.includes(ACTIVITIES.CONTROL)) {
                    vm.animalsDataTable.filters.push({
                        title: 'Проверено',
                        name: 'is_reviewed',
                        type: 'boolean'
                    })
                    vm.animalsDataTable.filters.push({
                        title: 'Дата проверки',
                        name: 'review_date',
                        type: 'dateFromTo'
                    })
                }
            }

            vm.animalsDataTable.actions.push(
                actions.create(() => {
                        vm.$router.push({name: 'animalCreate'})
                    }, vm.ability.can('create', 'Animal')
                )
            );

            vm.animalsDataTable.actions.push(
                actions.downloadXlsx((e, emittedEventNameStart, emittedEventNameFinish) => {
                    const downloadBaseUrl = api.animals.xlsx.list();
                    const downloadUrl = downloadBaseUrl + vm.$refs.animals.getQueryString();
                    EventBus.$emit(emittedEventNameStart)
                    download(downloadUrl)
                        .then((response) => {
                            vm.$bvToast.toast('Выгрузка завершена', {title: 'Выгрузка документа', autoHideDelay: 5000, variant: 'success'})
                        })
                        .catch(() => {
                            vm.$bvToast.toast('Не удалось произвести выгрузку', {title: 'Выгрузка документа', autoHideDelay: 5000, variant: 'danger'})
                        }).finally(() => {
                            EventBus.$emit(emittedEventNameFinish)
                        })
                    }, true, 'Выгрузить журнал учета и регистрации животных без владельцев')
                );
            
            if (vm.canWorkWithArchive()) {
                vm.animalsDataTable.actions.push(
                    new Action({
                        name: 'archive',
                        icon: 'archive',
                        variant: 'danger',
                        title: 'Архив',
                        showTitle: false,
                        emittedEvent: 'on-show-archive-controls',
                        handler: 'onShowArchiveControls',
                        available: true
                    }, (e, emittedEventNameStart, emittedEventNameFinish) => { vm.archiveControlsVisible = !vm.archiveControlsVisible })
                );

                vm.animalsDataTable.columns.push({
                    name: 'archive_date',
                    'title': 'Дата перемещения в архив'}
                )

            }

            if (vm.ability.can('destroy', 'Animal')) {
                vm.animalsDataTable.rowActions.push(new actions.objectDelete(Animal))
            }
        }
    }
</script>

<style scoped>

</style>